var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDivide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 481.15 481.15",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M465.275,160.39h-110.73v144.524c0,27.355-22.266,49.619-49.623,49.619H160.381v110.769 c0,8.757,7.094,15.849,15.851,15.849h289.044c8.777,0,15.865-7.092,15.865-15.849V176.254 C481.141,167.48,474.053,160.39,465.275,160.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.772,304.914V15.864C320.772,7.092,313.68,0,304.922,0H189.836v157.09c0,18.058-14.679,32.736-32.738,32.736H0.01 v115.088c0,8.756,7.094,15.847,15.864,15.847h289.048C313.68,320.761,320.772,313.67,320.772,304.914z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.062,0H15.874C7.104,0,0.01,7.092,0.01,15.864v140.747l144.216-0.517c6.544-0.023,11.836-5.335,11.836-11.879V0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivide);
export default __webpack_public_path__ + "static/media/divide.b9c6fe5a9e356871b8eda54c211b50f3.svg";
export { ForwardRef as ReactComponent };